import { render, staticRenderFns } from "./home-toutiao.vue?vue&type=template&id=f772f25a&"
import script from "./home-toutiao.vue?vue&type=script&lang=js&"
export * from "./home-toutiao.vue?vue&type=script&lang=js&"
import style0 from "./home-toutiao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports